






























































  import {Component, Vue} from "vue-property-decorator";
  import {unsubscribeInterface, getUnsubscribleSite} from "@/services/api";
  import {SubscribeResp} from "@/model/Subscribe";
import { logUnsubscribeInfo } from "@/services/unsubscribeLog";

  @Component({})
  export default class Unsubscribe extends Vue {
    public companyInfo: SubscribeResp = {};
    public content = '';
    copywriting = {
        Copywriting1 : "You've Been Unsubscribed.",
        Copywriting2 : "If you'd like to re-subscribe to this list, use the link below.",
        Copywriting3 : "re-subscribe",
    }
    img = '@/assets/img/subscribe/tuidingqueren.svg'
    status = 'UnsubscribeConfirm'
    companySite = ''

    // 点击确定退订
    UnsubscribeOk() {
        logUnsubscribeInfo({type:'Unsubscribe-OK'});
        this.status = 'UnsubscribeOk'
        this.img = '@/assets/img/subscribe/logo.svg'
        this.content = String(this.$route.query.content || '');
        unsubscribeInterface({content: this.content}).then(res => {
        this.companyInfo = res?.data?.data;
        // this.companySite = res?.data?.data?.site;
        if (res?.data?.data?.companyId == '173'){
            this.copywriting.Copywriting1 = "メールマガジンの配信停止を承りました。"
            this.copywriting.Copywriting2 = "配信の再開を希望される方は、下記のボタンより手続きをお進みください。"
            this.copywriting.Copywriting3 =  "メール配信を再開する"
        }else{
            this.copywriting.Copywriting1 = "You've Been Unsubscribed." 
            this.copywriting.Copywriting2 ="If you'd like to re-subscribe to this list, use the link below."  
            this.copywriting.Copywriting3 = "re-subscribe" 
        }
      })


    }
    // 点击No
    UnsubscribeNo() {
        logUnsubscribeInfo({type:'Unsubscribe-NO'});
        this.status = 'UnsubscribeNo'
        this.img = '@/assets/img/subscribe/butuiding.svg'
        this.content = String(this.$route.query.content || '');
        getUnsubscribleSite({content: this.content}).then(res => {
            this.companySite = res?.data?.data?.site || '';
          })
    }
    resubscribeInUnload() {
        logUnsubscribeInfo({type:'Unsubscribe-Resubscribe'});
        this.$router.push(`/resubscribe?content=${encodeURIComponent(this.content)}`)
    }
    hasHttpRegex(str) {
        const reg = new RegExp("http://");
        return reg.test(str);
    }
    browseWebsite() {
        logUnsubscribeInfo({type:'Unsubscribe-Website'});
        const url = this.hasHttpRegex(this.companySite) ? this.companySite : "http://" + this.companySite;
        window.open(url)
    }

    created() {
        logUnsubscribeInfo({type:'Unsubscribe-PV'});
      document.title = 'Unsubscribe';
      document.querySelector('meta[property="og:title"]')?.setAttribute('content', 'Unsubscribe');
    //   this.content = String(this.$route.query.content || '');
    //   unsubscribeInterface({content: this.content}).then(res => {
    //     this.companyInfo = res?.data?.data;
    //     this.companySite = res?.data?.data?.site;
    //     if (res?.data?.data?.companyId == '173'){
    //         this.copywriting.Copywriting1 = "メールマガジンの配信停止を承りました。"
    //         this.copywriting.Copywriting2 = "配信の再開を希望される方は、下記のボタンより手続きをお進みください。"
    //         this.copywriting.Copywriting3 =  "メール配信を再開する"
    //     }else{
    //         this.copywriting.Copywriting1 = "You've Been Unsubscribed." 
    //         this.copywriting.Copywriting2 ="If you'd like to re-subscribe to this list, use the link below."  
    //         this.copywriting.Copywriting3 = "re-subscribe" 
    //     }
       
        
    //   })
    //   getGuideDetail({}).then(res => {
    //     this.companySite = res?.data?.data?.companyInfo?.site || '';
    //   })
    }
  }
